// extracted by mini-css-extract-plugin
export default {"icon":"icon___bx6h2_common"};
    if(module.hot) {
      // 1792505593517
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  